export default __webpack_public_path__ + "static/media/Naman Jain.281f9f07.png";